<svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="3.5" width="5.33333" height="10.4762" fill="#003493"/>
<rect x="5.3335" y="3.5" width="5.33333" height="10.4762" fill="white"/>
<rect x="10.6665" y="3.5" width="5.33333" height="10.4762" fill="#DD4D48"/>
</svg>
